<script>
import common from './common.vue';

export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/dhcl/fanhui.png`,
      shoujiIcon: `${this.$cdnLink}/wanXin/dhcl/shoujihao.png`,
      mimaIcon: `${this.$cdnLink}/wanXin/dhcl/mima.png`,
      yanzhengmaIcon: `${this.$cdnLink}/wanXin/dhcl/yanzhenma.png?v=1` 
    }
  }
}
</script>
<style lang="scss" module>
@import "../../../assets/css/dhcl.scss";

.wrap {
  @include common-window();
  > header {
    position: relative;
    .fanhui {
      position: absolute;
      top: 0.45rem;
      left: 0.46rem;
      width: .35rem;
      height: .3rem;
    }
  }
  > main {
    padding-top: 0.2rem;
    .accountWrap {
      position: relative;
    }
    .inputWrap {
      @include common-inputWrap();
      justify-content: flex-start;
      padding-left: 0.25rem;
      .leftIcon {
        margin-right: 0.16rem;
      }
      &.pwd {
        margin-top: 0.12rem;
        margin-bottom: 0.12rem;
        > input {
          width: 3.5rem;
        }
      }
      &.code {
        margin-bottom: 0.14rem;
        > input {
          width: 2.7rem;
        }
        .getCode {
          display: flex;
          align-items: center;
          color: $primary-color;
          border-left: 1px solid $primary-color;
          padding-left: 0.2rem;
          height: 0.5rem;
          font-size: $font-nm-1;
        }
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      > span {
        padding: 0.12rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
      }
      .fanhui {
        position: absolute;
        top: 36px;
        right: 13px;
        width: 29px;
        height: 30px;
      }
    }
    > main {
      padding-top: 10px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        justify-content: flex-start;
        padding-left: 12px;
        .leftIcon {
          margin-right: 8px;
        }
        &.pwd {
          margin-top: 6px;
          margin-bottom: 6px;
          > input {
            width: 175px;
          }
        }
        &.code {
          margin-bottom: 7px;
          > input {
            width: 110px;
          }
          .getCode {
            display: flex;
            align-items: center;
            color: $primary-color;
            border-left: 1px solid $primary-color;
            padding-left: 10px;
            height: 25px;
            font-size: $font-nm;
          }
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 6px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
    }
  }
}
</style>